// @flow

const sortBucketsEntries = (buckets: Array<[string, number]>): Array<[string, number]> => (
  buckets.sort(([a], [b]) => {
    const caseA = a.toLowerCase();
    const caseB = b.toLowerCase();
    if (caseA < caseB) {
      return -1;
    }

    if (caseA > caseB) {
      return 1;
    }

    return 0;
  })
);

export default sortBucketsEntries;
